import React from "react";

import Sheet from "@/sot/primitives/Sheet.jsx";
import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";

export default function CallActionSheet({ open, onClose, title = "Call options", actions = [] }) {
  return (
    <Sheet open={open} onClose={onClose}>
      <TopBarCenter title={title} onBack={onClose} close />

      <div className="mt-4 overflow-hidden rounded-[16px] bg-[rgb(var(--clr-surface-cont-highest))]">
        {(actions || []).filter(Boolean).map((action, index, list) => (
          <button
            key={action.key || action.label || index}
            type="button"
            onClick={() => {
              action.onClick?.();
              onClose?.();
            }}
            className={[
              "flex w-full items-start justify-between gap-4 px-4 py-4 text-left",
              index !== list.length - 1 ? "border-b border-[rgba(var(--clr-outline-variant),0.55)]" : "",
            ].join(" ")}
          >
            <div className="min-w-0">
              <div className="text-body-large text-on-surface">{action.label}</div>
              {action.description ? (
                <div className="mt-1 text-body-medium text-on-surface-var">
                  {action.description}
                </div>
              ) : null}
            </div>
            {action.trailing ? <div className="shrink-0">{action.trailing}</div> : null}
          </button>
        ))}
      </div>
    </Sheet>
  );
}
